/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import '../../styles/dimension.scss';

const WantMoreDimension = () => {
  return (
    <div className="dimension">
      <div className="want-more">
        <span className="want-more__title">Want more filters?</span>
        <p>First, select a <a href="#department_list" className="want-more__link">department</a>.</p>
      </div>
    </div>
  );
};

WantMoreDimension.displayName = 'WantMoreDimension';

export { WantMoreDimension };